<cx-storefront></cx-storefront>
<sanofi-order-capping-toasts-container/>
